/**
 * Lightbox for video
 */

import { lightbox } from "./lightbox";

const triggers = document.querySelectorAll( '.js-video-lightbox' );

/**
 * Add Open Event
 *
 * @since 1.0.0
 * @return {void}
 */
const openLightbox = () => {

	triggers.forEach( ( trigger ) => {

		trigger.addEventListener( 'click', ( e ) => {

			e.preventDefault();
			const youTubeID = trigger.dataset.youtubeId;
			const iframe = generateIframe( youTubeID );
			const lightboxEl = document.querySelector( '.c-lightbox' );
			const lightboxContent = lightboxEl.querySelector( '.c-lightbox__content' );
			lightboxContent.appendChild( iframe );
			lightboxEl.classList.add( 'c-lightbox--open' );

		} );

	} );

}

/**
 * Generate Iframe
 *
 * @param {string} youTubeID
 * @return {HTMLElement}
 */
const generateIframe = ( youTubeID ) => {

	const iframe = document.createElement( 'iframe' );
	iframe.width = '100%';
	iframe.height = '100%';
	iframe.src = `https://www.youtube.com/embed/${ youTubeID }?autoplay=1&rel=0&showinfo=0&modestbranding=1&playsinline=1`;
	iframe.frameborder = '0';
	iframe.allow = 'accelerometer; autoplay; encrypted-media; gyroscope; picture-in-picture';
	iframe.allowfullscreen = true;
	iframe.loading = 'lazy';
	return iframe;

}

/**
 * External dependencies
 *
 * @package
 * @since 1.0.0
 */
const videoLightbox = () => {

	if ( triggers.length <= 0 ) {

		return;

	}
	lightbox( 'c-lightbox--video' );
	openLightbox();

}

export { videoLightbox };
